
export default function Footer() {
    return (
        <footer className="footer-container">
            <a className="footer-link" href="https://www.linkedin.com/in/vedansh-mishra-828549255">LinkedIn</a>
            <a className="footer-link" href="https://twitter.com/yashg_twt">Twitter</a>
            <a className="footer-link" href="https://instagram.com">Instagram</a>
            <p className="copyright">© Logic_Gates.</p>
        </footer>
    );
}